import AbsList from "../components/AbsList";
import ListItem from './ListItem';

export default class List extends AbsList{

    constructor(_name='', _store={}, _actions={}, _router={}, _el=''){
        super(_name, _store, _actions, _router, _el);
        
        this.listApiPath = `/search/polymorphs`;
        this.ListItemCon = ListItem;
        
        const watchQ = this.watch(this.store.getState, 'query', this.isEqual);
        this.store.subscribe( watchQ( this.stack.bind(this) ) );
        
        const watchG = this.watch(this.store.getState, 'grades', this.isEqual);
        this.store.subscribe( watchG( this.stack.bind(this) ) );
        
        const watchCard = this.watch(this.store.getState, 'card', this.isEqual);
        this.store.subscribe( watchCard( this.stack.bind(this) ) );

        const watchBuffCard = this.watch(this.store.getState, 'buffcard', this.isEqual);
        this.store.subscribe( watchBuffCard( this.stack.bind(this) ) );
        
        const watchWeapon = this.watch(this.store.getState, 'weapon', this.isEqual);
        this.store.subscribe( watchWeapon( this.stack.bind(this) ) );
        
        const watchF = this.watch(this.store.getState, 'favorite', this.isEqual);
        this.store.subscribe( watchF( this.stack.bind(this) ) );
        
        const watchP = this.watch(this.store.getState, 'page', this.isEqual);
        this.store.subscribe( watchP( this.stack.bind(this) ) );

        const watchParams = this.watch(this.store.getState, 'isParamsLoaded', this.isEqual);
        this.store.subscribe( watchParams( this.loadList.bind(this) ) );
    }

    getParams(){
        const { config, page, query, grades, card, buffcard, weapon, favorite } = this.store.getState(); 

        // @see https://sb-api-lineagew.plaync.com/search/docs/index.html#search-polymorphs
        let params = {
            locale: config.locale,
            page,
            size: this.pageSize
        };
        this.makeParams(params, 'keyword', query );
        this.makeParams(params, 'gradeIds', grades),
        this.makeParams(params, 'polymorphCardTypes', card);
        this.makeParams(params, 'buffCardType', buffcard);
        this.makeParams(params, 'weaponTypeIds', weapon);
        this.makeParams(params, 'favorite', favorite);

        return params;
    }

} // end of class